import { IStore } from 'store/types';
import { IPOSCategory, IPOSLaborEmployee } from 'types';

export const selectPOSCategories =
  () =>
  (state: IStore): IPOSCategory[] | undefined =>
    state?.collections?.pos?.categories;

export const selectPOSEmployees =
  () =>
  (state: IStore): IPOSLaborEmployee[] | undefined =>
    state?.collections?.pos?.employees;
